<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'live-lists'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">Live</h1>
							<el-button class="pc-hidde-button" size="mini" type="success" icon="el-icon-circle-plus-outline" @click="toApply">Apply</el-button>
						</div>
						<div class="search-container">
							<div class="search-block">
								<el-select v-model="staVal" placeholder="Please select">
								    <el-option v-for="item in staOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
							<div class="search-btns" style="margin-top: 5px;">
								<el-button type="primary" size="small" @click="doSearch">Search</el-button>
								<el-button size="small" @click="resetQuery">Reset
								</el-button>
								<el-button class="mobile-hidde-button" size="small" type="success" icon="el-icon-circle-plus-outline" @click="toApply">Apply</el-button>
							</div>
						</div>
						<template v-if="lists.length > 0">
							<div class="table-wrap" >
								<el-table :data="lists" style="width: 100%" v-loading="tableLoading" empty-text="No Data">
									<el-table-column prop="roomNo" label="#" width="250"></el-table-column>
									<el-table-column prop="roomName" label="Room Name" min-width="220"></el-table-column>
									<el-table-column prop="playStartTime" label="Creation time" width="220"></el-table-column>
									<el-table-column prop="playTime" label="Duration" width="170">
									</el-table-column>
									<el-table-column prop="playNum" label="Number of people" width="170"></el-table-column>
									<!-- 发表 -->
									<el-table-column prop="orderNum" label="Order quantity" width="170">
										<template v-slot="scope">
											<el-tag type="success">{{scope.row.orderNum}}</el-tag>
										</template>
									</el-table-column>
									<el-table-column prop="robotId" label="Digital human number" width="200"></el-table-column>
							
									<el-table-column prop="sta" label="Status" width="200">
										<template v-slot="scope">
											<el-tag v-if="scope.row.sta == 0">Under review</el-tag>
											<el-tag v-if="scope.row.sta == 1">Live streaming</el-tag>
											<el-tag v-if="scope.row.sta == 2">Ended</el-tag>
											<el-tag v-if="scope.row.sta == 3">Offline</el-tag>
											<el-tag v-if="scope.row.sta == 4">Review failed</el-tag>
										</template>
									</el-table-column>
							
									<el-table-column fixed="right" label="Option" width="170">
										<template slot-scope="scope">
											<div style="float: left;margin-right: 10px;">
												<el-button type="text" size="small" @click="openPage('live-detail/?no='+scope.row.roomId)">
													view
												</el-button>
												<el-button v-if="scope.row.sta == 1 || scope.row.sta == 3" type="text" size="small" @click="changeLiveSta(scope.row,1)">
													Go Live
												</el-button>
												<el-button v-if="scope.row.sta == 5" type="text" size="small" @click="changeLiveSta(scope.row,2)">
													End Live
												</el-button>
												<el-button type="text" size="small" @click="doDelete(scope.row)">
													Delete
												</el-button>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<div class="table-mobile-wrapper">
								<div class="order-item-wrapper" v-for="item in lists" >
									<div class="tool-btns">
										<el-dropdown >
											<div class="btn">
												<i class="el-icon-more"></i>
											</div>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item>
													<div v-if="item.sta == 1 || item.sta == 3" @click.stop="changeLiveSta(item,1)">
														<span>Go Live</span>
													</div>
													<div v-if="item.sta == 5" @click.stop="changeLiveSta(item,2)">
														<span>End Live</span>
													</div>
													<div @click.stop="doDelete(item)">
														<span>Delete</span>
													</div>
												</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</div>
									<div @click="openPage('live-detail?no='+item.roomId)">
										<div class="order-item-header">
											<div class="order-no"># {{ item.roomNo }}</div>
											<!-- <span class="o-sta-txt">
												<el-tag v-if="item.sta == 0">Under review</el-tag>
												<el-tag v-if="item.sta == 1">Live streaming</el-tag>
												<el-tag v-if="item.sta == 2">Ended</el-tag>
												<el-tag v-if="item.sta == 3">Offline</el-tag>
												<el-tag v-if="item.sta == 4">Review failed</el-tag>
																	
											</span> -->
										</div>
										<div class="order-item-inner">
											<div class="order-item-label">
												<div class="o-item-label">Room Name:</div>
												<div class="o-item-value"> {{ item.roomName }}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">Status:</div>
												<div class="o-item-value">
													<el-tag v-if="item.sta == 0">Under review</el-tag>
													<el-tag v-if="item.sta == 1">Live streaming</el-tag>
													<el-tag v-if="item.sta == 2">Ended</el-tag>
													<el-tag v-if="item.sta == 3">Offline</el-tag>
													<el-tag v-if="item.sta == 4">Review failed</el-tag>
												</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">Creation time:</div>
												<div class="o-item-value">{{ item.playStartTime }}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">Duration:</div>
												<div class="o-item-value">{{ item.playTime }}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">Number of people:</div>
												<div class="o-item-value o-price">{{ item.playNum }}</div>
											</div>
																	
											<div class="order-item-label">
												<div class="o-item-label">Order quantity:</div>
												<div class="o-item-value o-price">{{ item.orderNum }}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">Digital human number:</div>
												<div class="o-item-value">{{ item.robotId }}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="page-contrainer d-flex">
								<el-pagination :page-count="isMobile ? 4 : 10" background layout="prev, pager, next" :total="total"
									 :current-page.sync="queryParams.pageNum"
									@current-change="init">
								</el-pagination>
							</div>
						</template>
						
						<template v-else>
							<div style="width: 100%;margin-top: 30px;height: auto;">
								<empty></empty>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<tabBar></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import empty from '../../components/empty.vue'
	import { getLiveList,editLiveOnline,delRoom } from "@/api/live";

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar,
			empty
		},
		data() {
			return {
				tableLoading: false,
				total: 0,
				lists: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				isMobile: false,
				staOption:[{
					value: '1',
					label: 'Application in progress'
				},
				{
					value: '2',
					label: 'Live streaming'
				},
				{
					value: '3',
					label: 'The live broadcast has ended.'
				}],
				staVal:''
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.init();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
			},
			init() {
				var params = {
					pageNum:this.queryParams.pageNum,
					pageSize:this.queryParams.pageSize
				}
				this.tableLoading = true
				getLiveList(params).then(res => {
					this.tableLoading = false
					if (res.code == 200) {
						this.lists = res.data
						this.total = res.total
					}
				})
			},
			resetQuery(){
				this.staVal = ''
				this.queryParams.pageNum = 1
				this.init()
			},
			doSearch(){
				this.queryParams.pageNum = 1
				this.init()
			},
			toApply(){
				this.openPage('live-add')
			},
			changeLiveSta(e,sta){
				var params = {
					roomId:e.roomId,
					onlineNum:sta
				}
				const loading = this.$loading({
				    lock: true,
				    text: 'Loading',
				    spinner: 'el-icon-loading',
				    background: 'rgba(255, 255, 255, 0.7)'
				});
				editLiveOnline(params).then(res => {
					loading.close();
					if (res.code == 200) {
						this.init();
					}
				})
			},
			doDelete(e){
				this.$confirm('This operation will delete the live broadcast room. Do you want to continue?', 'Tips', {
				    confirmButtonText: 'Confirm',
				    cancelButtonText: 'Cancel',
				    type: 'warning',
					customClass:'message-box-mobile'
				}).then(() => {
				    var params = {
				    	roomId:e.roomId
				    }
				    const loading = this.$loading({
				        lock: true,
				        text: 'Loading',
				        spinner: 'el-icon-loading',
				    	background: 'rgba(255, 255, 255, 0.7)'
				    });
				    delRoom(params).then(res => {
				    	loading.close();
				    	if (res.code == 200) {
				    		this.$message({
				    			message: `Successfully`,
				    			type: 'success'
				    		});
				    		this.init();
				    	}else{
				    		this.$message.error('Fail!');
				    	}
				    })
				}).catch(() => {
				             
				});
				
			}
		}
	}
</script>
<style scoped>
	.order-item-wrapper {
		position: relative;
	}
	.order-item-wrapper .order-item-header {
		height: 30px;
		line-height: 30px;
	}
	.order-item-header .order-no {
		width: calc(100% - 20px);
		max-width: unset;
	}
	.search-block {
		max-width: 160px;
	}
	.card-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.mobile-hidde-button {
		display: inline-block !important;
	}
	.pc-hidde-button {
		display: none !important;
	}
	@media (max-width: 767px) {
		.mobile-hidde-button {
			display: none !important;
		}
		.pc-hidde-button {
			display: block !important;
		}
	}
	.tool-btns {
		position: absolute;
		top: 7px;
		right: 12px;
		z-index: 3;
	}
</style>
<style>
	@media (max-width: 767px) {
		.message-box-mobile {
			width: 80% !important;
		}
	}
	
</style>
